<template>
  <div class="table-component">
    <!-- 表格顶部操作 -->
    <div v-if="tableTopOperate" class="table-component-operate" :style="tableTopOperate.align === 'left' ? {justifyContent: 'flex-start'} : {justifyContent: 'flex-end'}" >
      <el-button size="mini" class="unify-btn" v-for="(item, index) in tableTopOperate.options" :key="index" @click.stop="tableHandle(item.event)" :loading="item.loading">{{item.label}}</el-button>
    </div>
    <!-- 自定义表格顶部操作 -->
    <slot name="customerTableTopOperate"></slot>
    <!-- 表格 -->
    <el-table
      ref="multiTable"
      :data="tableConfig.data"
      style="width: 100%"
      :show-summary="tableShowSummary"
      :summary-method="tableGetSummaries"
      :row-class-name="tableRowClassName"
      :row-style="{color: '#252525'}"
      fixed
      :border="true"
      class="common_table table"
      @current-change="current_change"
      @row-doubleClick="row_dbclick"
      @row-click="row_singleclick"
      @selection-change="selection_change"
      v-loading="tableLoading"
      :highlight-current-row="highlightCurrentRow"
      :max-height="tableHeight"
    >
      <el-table-column v-if="multi" type="selection" align="left"></el-table-column>
      <el-table-column v-if="number" :label="'No.'" type="index" :index="1" width="60" align="left" :fixed="tableIndexFixed"></el-table-column>
      <el-table-column v-if="customizeTitle" :label="customizeTitle" type="index" :index="1" width="60" align="left"></el-table-column>
      <el-table-column v-for="(th, index) in tableConfig.thead" :prop="th.prop" :label="th.label" :min-width="headerColumnWidth(th.label, th.width)" :key="index" :align="th.align || 'left'" :sortable="th.sortable" :show-overflow-tooltip="!th.notShowOverflowTooltip" :fixed="th.fixed" :render-header="th.renderHeader || null">
        <!-- 自定义表头 -->
        <!-- <template slot="header" #default="headerScope" v-if="th.slotHeader">
          <el-input
            v-model="search"
            size="mini"
            placeholder="输入关键字搜索"/>
        </template> -->
        <!-- 通过设置 Scoped slot 来自定义列模板 -->
        <template #default="scope" v-if="(!th.children)">
          <!-- 自定义 -->
          <!-- <slot :row="scope.row" :propName="th.prop" name="tableContentSlot" v-if="th.isSlot"></slot> -->
          <slot :row="scope.row" :propName="th.prop" :isTime="th.isTime" v-if="th.isSlot"></slot>
          <!-- link -->
          <el-link :underline="th.linkUnderline === 'false' ? false : true" :type="th.linkType || 'warning'" v-else-if="th.event && eventStatus && (scope.row[th.prop] !== '-')" @click.stop="tableHandle(th.event, scope.$index, scope.row)">{{ th.extra ? th.extra[scope.row[th.prop]] : scope.row[th.prop] }}</el-link>
          <!-- linkArr -->
          <template v-else-if="th.isLinkArr">
            <el-link v-for="linkItem in th.linkArr" :key="linkItem.title" class="link-arr-item" :underline="linkItem.linkUnderline === true ? true : false" :type="linkItem.linkType || 'warning'" @click.stop="tableHandle(linkItem.event, scope.$index, scope.row)">{{ linkItem.title }}</el-link>
          </template>
          <!-- 枚举 -->
          <template v-else>{{ th.extra ? th.extra[scope.row[th.prop]] : scope.row[th.prop] }}</template>
        </template>
        <!-- 多级表头 -->
        <template v-if="th.children">
          <el-table-column v-for="(cItem, cIdx) in th.children" :key="cIdx" :prop="cItem.prop" :label="cItem.label" :width="cItem.width" :align="cItem.align || 'left'" :render-header="cItem.renderHeader || null">
            <template #default="scopeChild">
              <!-- 自定义 -->
              <!-- <slot :row="scopeChild.row" :propName="cItem.prop" name="tableContentSlot" v-if="cItem.isSlot"></slot> -->
              <slot :row="scope.row" :propName="th.prop" :isTime="th.isTime" v-if="th.isSlot"></slot>
              <!-- link -->
              <el-link :underline="cItem.linkUnderline === 'false' ? false : true" :type="cItem.linkType || 'warning'" v-else-if="cItem.event && eventStatus && (scopeChild.row[cItem.prop] !== '-')" @click.stop="tableHandle(cItem.event, scopeChild.$index, scopeChild.row)">{{ cItem.extra ? cItem.extra[scopeChild.row[cItem.prop]] : scopeChild.row[cItem.prop] }}</el-link>
              <!-- linkArr -->
              <template v-else-if="cItem.isLinkArr">
                <el-link v-for="linkItem in cItem.linkArr" :key="linkItem.title" class="link-arr-item"  :underline="linkItem.linkUnderline === true ? true : false" :type="linkItem.linkType || 'warning'" @click.stop="tableHandle(linkItem.event, scopeChild.$index, scopeChild.row)">{{ linkItem.title }}</el-link>
              </template>
              <!-- 枚举 -->
              <template v-else>{{ cItem.extra ? cItem.extra[scopeChild.row[cItem.prop]] : scopeChild.row[cItem.prop] }}</template>
            </template>
          </el-table-column>
        </template>
      </el-table-column>
      <slot></slot>
      <!-- 操作列 -->
      <el-table-column v-if="tableConfig.operate" :label="'operation'" :width="tableConfig.operateWidth ? tableConfig.operateWidth : opWidth" fixed="right">
        <!-- 通过设置 Scoped slot 来自定义列模板 -->
        <template #default="scope">
          <template v-for="(item, index) in tableConfig.operate">
            <!-- 操作按钮单条件key展示或者无条件展示 -->
            <template>
              <el-button
                v-if="item.show ? item.show.value[scope.row[item.show.key]] : true"
                :key="index"
                :type="item.extra ? item.type[scope.row[item.show.key]] : item.type"
                size="mini"
                plain
                @click="tableHandle(item.event, scope.$index, scope.row)"
                :class="item.redColor ? 'red-font-color' : ''"
                :style="item.fontColor ? { color: item.fontColor } : {}"
              >
                {{item.extra ? item.extra.value[scope.row[item.extra.key]] : item.name}}
              </el-button>
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  name: 'Table',
  props: {
    single: { // 是否允许当表格的当前行发生变化的时候会触发该事件
      type: Boolean,
      default: false,
    },
    highlightCurrentRow: { // 是否单选
      type: Boolean,
      default: false,
    },
    multi: { // 是否允许选择项发生变化时触发事件
      type: Boolean,
      default: false,
    },
    eventStatus: {
      type: Boolean,
      default: false,
    },
    doubleClick: { // 是否允许单元格双击触发事件
      type: Boolean,
      default: false,
    },
    singleClick: { // 是否允许行点击触发事件
      type: Boolean,
      default: false,
    },
    tableShowSummary: { // 是否在表尾显示合计行
      type: Boolean,
      default: false,
    },
    tableSummaryFirstTitle: { // 表尾合计行第一个空格的标题
      type: String,
      default() {
        return 'summary'
      },
    },
    tableGetSummaries: { // 自定义表尾合计规则
      type: Function,
      default: this.defaultGetSummaries,
    },
    moneySummaryItemList: {}, // 表尾合计行展示金额合计的列（item为tableData的prop）
    numberSummaryItemList: {}, // 表尾合计行展示数字合计的列（item为tableData的prop）
    period: { // 展示期号
      type: Boolean,
      default: false,
    },
    number: { // 展示序号
      type: Boolean,
      default: false,
    },
    customizeTitle: { // 展示自定义序号标题
      type: String,
      default: '',
    },
    sortable: { // 对应列是否可以排序
      type: Boolean,
      default: false,
    },
    classKey: { // 行的类名
      type: String,
      default: '',
    },
    toggleSelect: {
      type: Array,
      default: () => [],
    },
    tableConfig: { // 父组件传过来的表格数据
      required: true,
    },
    tableLoading: { // loading状态
      type: Boolean,
      default: false,
    },
    tableTopOperate: { // 表格顶部操作
      type: Object,
      default: null,
    },
    tableHeight: { // 表格最大高度
      type: Number | String,
      default: 500,
    },
    tableIndexFixed: { // 表格序号是否固定
      type: String,
      default: 'left',
    }
  },
  watch: {
    toggleSelect(rows) {
      console.log(32)
      rows.length > 0 ? this.toggleRowSelection() : ''
    }
  },
  computed: {
    opWidth() {
      let width = 0;
      const target = this.tableConfig.operate ? this.tableConfig.operate : [];
      target.forEach((item) => {
        if (item.name.length === 2) {
          width += 60;
        } else {
          width += 90;
        }
      });
      width += ((target.length - 1) * 10) + 20;
      return width;
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    tableRowClassName(row, rowIndex) {
      row.index = rowIndex;
      if (row.loanStatus && row.loanStatus === '1') {
        return 'red-color-row'
      }
      if (!row[this.classKey]) {
        return `not-${this.classKey}-row`;
      }
      return '';
    },
    toggleRowSelection() {
      if (this.toggleSelect.length) {
        this.toggleSelect.forEach((row) => {
          this.$refs.multiTable.toggleRowSelection(row, true);
        });
      }
    },
    tableHandle(e, index, row) {
      this.$emit('tableHandle', { e, index, row });
    },
    selection_change(row) {
      if (this.multi) {
        this.$emit('tableHandle', { e: 'multi', row });
      }
    },
    row_dbclick(row, event) {
      if (this.doubleClick) {
        this.$emit('tableHandle', { e: 'doubleClick', row, event });
      }
    },
    current_change(currentRow, oldCurrentRow, event) {
      this.$emit('tableHandle', {
        e: 'single', 
        currentRow,
        oldCurrentRow,
        event
      });
    },
    row_singleclick(row, event) {
      if (this.singleClick) {
        this.$emit('tableHandle', { e: 'singleClick', row, event });
      }
    },
    // 底部栏合计规则
    defaultGetSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // 遍历列
      columns.forEach((ele, index) => {
        // 如果是第一列
        if (index === 0) {
          sums[index] = this.tableSummaryFirstTitle; // 一般展示合计
          return;
        }
        // 如果是其他列
        if (this.moneySummaryItemList.indexOf(ele.property) > -1) { // 如果该列是要展示金额合计的列
          const values = data.map((item) => (item[ele.property])); // 当列每一行的值
          sums[index] = 0; // 初始化每列合计值
          // let values: any = [];
          values.length > 0 && values.map((item) => {
            // 去掉千分位
            if (typeof item === 'string') {
              item = item.replace(/,/g, '');
            }
            // 去掉undefined 和 NaN的情况
            if (!item) {
              item = 0;
            }
            // 保留小数点后两位
            item = Number(item).toFixed(2);
            // 转为number类型
            item = Number(item);
            // values.push(item);
            sums[index] += item;
          });
          sums[index] = formatMoney(sums[index]); // 格式化金额
        } else if (this.numberSummaryItemList.indexOf(ele.property) > -1) { // 如果该列是要展示数字合计的列
          const values = data.map((item) => (item[ele.property])); // 当列每一行的值
          sums[index] = 0; // 初始化每列合计值
          values.length > 0 && values.map((item) => {
            // 去掉千分位
            if (typeof item === 'string') {
              item = item.replace(/,/g, '');
            }
            // 去掉undefined 和 NaN的情况
            if (!item) {
              item = 0;
            }
            // 转为number类型
            item = Number(item);
            sums[index] += item;
          });
        } else { // 如果是不要展示合计的列，则底部合计为空字符串
          sums[index] = '';
        }
      });
      return sums;
    },
    // 用于控制非操作栏的列标题最小宽度，防止表头列标题换行
    headerColumnWidth(laberName, initWidth) {
      if (initWidth) {
        return initWidth;
      } else {
        const laberLength = laberName.length;
        return laberLength * 27;
      }
    },
  }
}
</script>
<style scoped>
.table-component {
  width: 100%;
}

.table-component-operate {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
}

/* .common_table >>> .el-table__fixed {
  height: auto !important;
  bottom: 17px !important;
}
.common_table >>> .el-table__fixed::before, .common_table >>> .el-table__fixed-right::before {
  display:none;
} */
.common_table >>> .el-table__body-wrapper{
  z-index: 2;
}
/* 解决合计cell与常规cell不对齐 */
.common_table >>> .cell {
  width: 100% !important;
}


.common_table >>> .el-table__body-wrapper::-webkit-scrollbar {
    /* width: 20px; */
    height: 15px;
}
.common_table >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
}
.common_table >>> .el-table__body-wrapper::-webkit-scrollbar-track {
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue